import VideoContent from './VideoContent'

export default VideoContent
